import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import type { JSX } from 'react';

export const GuestOnly = ({ children }: { children: JSX.Element }) => {
  const { isLoggedIn } = useAuth();

  if (isLoggedIn) {
    // 로그인 상태라면 로그인 페이지가 아닌 기본 진입 페이지로 보냄
    return <Navigate to="/player-list" replace />;
  }

  // 로그인 안 한 경우에만 children (ex: <Login />)을 렌더링
  return children;
};
